'use client';
import { createContext, useContext } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const SwanI18nContext = createContext(null);
SwanI18nContext.displayName = 'SwanI18nContext';
function useInternalOptionalSwanI18nContext() {
    return useContext(SwanI18nContext);
}
function useSwanI18nContext() {
    return useNonNullishContext(SwanI18nContext, "This component can only be used within SWAN's new i18n system. Please opt into i18n before using this component.");
}

export { SwanI18nContext, useInternalOptionalSwanI18nContext, useSwanI18nContext };
